import { getIsWeb } from "../platformHelper";

const REDIRECT_TO_STORAGE_KEY = "redirect_to";

export function hasRedirectToInSessionStorage() {
  if (!getIsWeb()) {
    return false;
  }

  try {
    return Boolean(window.sessionStorage.getItem(REDIRECT_TO_STORAGE_KEY));
  } catch (error) {
    return false;
  }
}

export function getRedirectToFromSessionStorage() {
  if (!getIsWeb()) {
    return null;
  }

  try {
    return window.sessionStorage.getItem(REDIRECT_TO_STORAGE_KEY);
  } catch (error) {
    return null;
  }
}

export function setRedirectToInSessionStorage(redirectTo) {
  if (!getIsWeb() || !redirectTo) {
    return;
  }

  try {
    window.sessionStorage.setItem(REDIRECT_TO_STORAGE_KEY, redirectTo);
  } catch (error) {}
}

export function clearRedirectToInSessionStorage() {
  if (!getIsWeb()) {
    return;
  }

  try {
    window.sessionStorage.removeItem(REDIRECT_TO_STORAGE_KEY);
  } catch (error) {}
}
